import Cart from "../components/cart/Cart";
import "./CartPage.css";

const CartPage = () => {
  return (
    <div className="single-cart-page">
      <Cart />
    </div>
  );
};

export default CartPage;
